import { progressFill, progressTrack } from './members-area.css'

export function ProgressBar({
  value,
  label,
  className,
}: {
  value: number
  label: string
  className?: string
}) {
  const clamped = Math.min(100, Math.max(0, Math.round(value)))
  return (
    <div
      className={className ?? progressTrack}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
    >
      <span className={progressFill} style={{ width: `${clamped}%` }} />
    </div>
  )
}
